import React from 'react';

import {
  useSoyuzLocales,
  useSoyuzClientConfig,
  trans,
  useSoyuzExperiment
} from '@spotahome/soyuz/client';

import RebrandingToast from '@spotahome/marketplace-common/src/components/RebrandingToast';

import { useTenantTypeContext } from '@spotahome/marketplace-common/src/context/TenantTypeContext';

import Search from './Search';

const SearchContainer = props => {
  const clientConfig = useSoyuzClientConfig();
  const { current } = useSoyuzLocales();
  const { tenantType } = useTenantTypeContext();

  const layoutWithFooterExperiment = useSoyuzExperiment('FooterOnSearch');

  const isFooterInSearchPage =
    layoutWithFooterExperiment.get('behaviour') === 'variant';

  return (
    <>
      <Search
        {...props}
        clientConfig={clientConfig}
        currentLocale={current}
        isFooterInSearchPage={isFooterInSearchPage}
      />
      {tenantType === 1 && (
        <RebrandingToast
          message={trans('lead.nurturing.toast.save.alert')}
          category="Search"
          action="LNToast-save-alert"
        />
      )}
    </>
  );
};

export default SearchContainer;
